import React, { Component, Suspense } from 'react'
import { HashRouter, Route, Routes, Navigate } from 'react-router-dom'
import './scss/style.scss'
import AuthService from './services/AuthSevice'
import { useSelector, useDispatch } from 'react-redux'


const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
const Home = React.lazy(() => import('./views/pages/home/Home'))

const Auth = new AuthService();

const App = () => {
  const loggedIn = Auth.loggedIn();
  const dispatch = useDispatch()
  const logIn = useSelector((state) => state.isLoggedIn)
  dispatch({ type: 'set', isLoggedIn: loggedIn })
  console.log("xx x x x logIn ", logIn)
  return (
    <HashRouter>
      <Suspense fallback={loading}>
        <Routes>
          <Route exact path="/login" name="Login Page" element={<DefaultLayout />} />
          <Route exact path="/register" name="Register Page" element={<Register />} />
          <Route exact path="/404" name="Page 404" element={<Page404 />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          <Route exact path="/home/*" name="Login Page" element={logIn ? <Home /> :  <Navigate to='/login' />} />
          <Route path="*" name="Home" element={loggedIn ? <Home /> : <Navigate to='/login' />} />
        </Routes>
      </Suspense>
    </HashRouter>
  )
}

export default React.memo(App)
